import validate from "/Users/junyaoc/Documents/lab/oxb-web-5-cf/node_modules/.pnpm/nuxt@3.14.1592_@parcel+watcher@2.5.0_@types+node@22.10.2_bufferutil@4.0.8_db0@0.2.1_idb_bae1724a876f977685b42ce607353081/node_modules/nuxt/dist/pages/runtime/validate.js";
import redirect_45global from "/Users/junyaoc/Documents/lab/oxb-web-5-cf/middleware/redirect.global.ts";
import manifest_45route_45rule from "/Users/junyaoc/Documents/lab/oxb-web-5-cf/node_modules/.pnpm/nuxt@3.14.1592_@parcel+watcher@2.5.0_@types+node@22.10.2_bufferutil@4.0.8_db0@0.2.1_idb_bae1724a876f977685b42ce607353081/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  redirect_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  account: () => import("/Users/junyaoc/Documents/lab/oxb-web-5-cf/middleware/account.ts"),
  app: () => import("/Users/junyaoc/Documents/lab/oxb-web-5-cf/middleware/app.ts"),
  claim: () => import("/Users/junyaoc/Documents/lab/oxb-web-5-cf/middleware/claim.ts"),
  landing: () => import("/Users/junyaoc/Documents/lab/oxb-web-5-cf/middleware/landing.js")
}